













































import { PropType } from '@nuxtjs/composition-api';
import type { CombiDeal } from './CombiDeals.vue';

export default {
  props: {
    firstProduct: {
      type: Object,
      default: () => ({})
    },
    productSpliId: {
      type: Number,
      required: true,
      default: 0
    },
    combideal: {
      type: Object as PropType<CombiDeal>,
      default: () => ({})
    }
  }
};
